<template>
  <div>
    <span
      :class="premiumClasses ?? `fw-bold fs-30`"> &dollar;{{ premiumAmount?.split('.')[0] }}
    </span>
    <sup v-if="superscriptClasses" :class="superscriptClasses" >
      .{{ ((premiumAmount?.split('.')[1] ?? '') + '00').substr(0, 2) }}
    </sup>
    <span v-else :class="premiumClasses ?? `fw-bold fs-30`">.{{ ((premiumAmount?.split('.')[1] ?? '') + '00').substr(0, 2) }}
    </span>
    <span :class="subtextClasses ?? `fs-12`">{{ subtext }}</span>
  </div>
</template>

<script>
export default {
  name: "CurrencyPresentation",
  props: ['premiumAmount', 'subtext', 'superscriptClasses', 'premiumClasses', 'subtextClasses'],
};
</script>

